function HideMenuItemsModalController(
    $scope,
    $uibModalInstance,
    numItems,
    numOptions,
    callback
) {
    this.modalInstance = $uibModalInstance;
    this.callback = callback;

    $scope.numItems = numItems;
    $scope.numOptions = numOptions;
    $scope.doNotShowAgain = false;

    $scope.cancel = () => {
        this.modalInstance.close();
    }

    $scope.ok = () => {
        if($scope.doNotShowAgain) {
            localStorage.setItem("do-not-show-hide-menu-items", true);
        }

        this.callback();
        this.modalInstance.close();
    }
}

angular.module('dashboard')
    .controller('HideMenuItemsModalController',
        [
            '$scope',
            '$uibModalInstance',
            'numItems',
            'numOptions',
            'callback',
            HideMenuItemsModalController
        ])


